import React from "react";
import {ProductionOrderFormCreate} from "../../components/production-order/form/ProductionOrderFormCreate";

export function CreateProductionOrderForm() {
    return (
        <ProductionOrderFormCreate/>
    )
}